module.exports = __webpack_public_path__ + "0880793d241ddb864718d2e49ebdb45c.jpg";